import { render, staticRenderFns } from "./NotesDialog.vue?vue&type=template&id=0d26da9c&scoped=true"
import script from "./NotesDialog.vue?vue&type=script&lang=js"
export * from "./NotesDialog.vue?vue&type=script&lang=js"
import style0 from "./NotesDialog.vue?vue&type=style&index=0&id=0d26da9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d26da9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d26da9c')) {
      api.createRecord('0d26da9c', component.options)
    } else {
      api.reload('0d26da9c', component.options)
    }
    module.hot.accept("./NotesDialog.vue?vue&type=template&id=0d26da9c&scoped=true", function () {
      api.rerender('0d26da9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/dialogs/NotesDialog.vue"
export default component.exports